'use strict';

angular.module('adf')
.service('performanceDashboardService', function($http, hostUrl, leanFilterService) {
	return {
		getMetricList: getMetricList,
		getMetrics: getMetrics
	};

	function getMetrics() {
		var url = hostUrl + '2/factndx/' + leanFilterService.getFactoryList() + '/Metrics';
		return $http.get(url)
			.then(getMetricsComplete)
			.catch(getMetricsFailed);

		function getMetricsComplete(response) {
			return response.data;
		}

		function getMetricsFailed(error) {
			return [];
		}
	}

	function getMetricList() {
		var url = hostUrl + '2/factndx/' + leanFilterService.getFactoryList() + '/Metrics/Performance';
		var vStreams = leanFilterService.getSelectedIds('valueStream');
		var types = leanFilterService.getSelectedIds('typeName');
		var categories = leanFilterService.getSelectedIds('category');
		var metrics = leanFilterService.getSelectedIds('metric');
		var frequency = leanFilterService.getSelectedIds('metricFrequency');

		var qryParams = {};

		if (vStreams && vStreams.length > 0 && vStreams[0] !== 'LDNA_A_S' &&
			vStreams.length !== leanFilterService.getFilterById('valueStream').objectList.length) {
			qryParams.vstreams = vStreams.toString();
		}
		if (frequency && frequency.length === 1 && frequency[0] !== 'LDNA_A_S') {
			qryParams.frequency = frequency[0];
		}
		if (types && types.length > 0 && types[0] !== 'LDNA_A_S' &&
			types.length !== leanFilterService.getFilterById('typeName').objectList.length) {
			qryParams.types = types.toString();
		}
		if (categories && categories.length > 0 && categories[0] !== 'LDNA_A_S' &&
			categories.length !== leanFilterService.getFilterById('category').objectList.length) {
			qryParams.categories = categories.toString();
		}
		if (metrics && metrics.length > 0 && metrics[0] !== 'LDNA_A_S') {
			qryParams.metrics = metrics.toString();
		}
		if (qryParams && !jQuery.isEmptyObject(qryParams)) {
			url = url + '?' + jQuery.param(qryParams);
		}
		return $http.get(url)
			.then(getMetricListComplete)
			.catch(getMetricListFailed);

		function getMetricListComplete(response) {
			var metrics = [];
			if (leanFilterService.getFactoryList(true).length === 1) {
				metrics = response.data;
			} else {
				// if cross-site, use crossSiteName to only keep one copy of each metric
				var seen = {};
				for (var i = 0; i < response.data.length; i++) {
					var metric = response.data[i];
					if (!seen.hasOwnProperty(metric.crossSiteName)) {
						seen[metric.crossSiteName] = true;
						metrics.push(metric);
					}
				}
			}
			return metrics;
		}

		function getMetricListFailed(error) {
			return [];
		}
	}
});